import React, {useState} from 'react';
import styled from "styled-components";
import {
    RiAccountCircleFill,
    RiGroupLine,
    RiLogoutBoxLine,
    RiMessage3Line,
    RiSettings2Line,
    RiUser2Line
} from "react-icons/ri";
import ChatAccounts from "./ChatAccounts";
import Profile from "./Profile";
import Settings from "./Settings";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {logout} from "../../Redux/actions/authAction";
import FriendRequests from "./FriendRequests";
import Groups from "./Groups";
import Logo from "./Logo";
import multiavatar from "@multiavatar/multiavatar/esm";

const SideMenu = ({logout, user}) => {
    const [menuIndex, setMenuIndex] = useState(0);

    const renderSwitch = (param) => {
        switch (param) {
            case -1:
                return (<div className="render-switch-container">
                    <Profile/>
                </div>);

            case 0:
                return (<div className="render-switch-container">
                    <ChatAccounts/>
                </div>);

            case 1:
                return (<div className="render-switch-container">
                    <FriendRequests/>
                </div>);

            case 2:
                return (<div className="render-switch-container">
                    <Groups/>
                </div>);

            case 3:
                return (<div className="render-switch-container">
                    <Settings/>
                </div>);
            default:
                return (<div className="render-switch-container">
                    <ChatAccounts/>
                </div>);
        }
    }

    const menuHorizontal = () => {
        return (
            <div className='menu-container-horizontal'>
                <div className="top">
                    <Logo/>
                </div>
                <div className="mid">
                    <div className={`menu-icon-container tooltip ${menuIndex === 0 ? "menu-icon-selected" : null}`}
                         onClick={() => setMenuIndex(0)}>
                        <span className="tooltiptext" style={{left:6}}>Chats</span>
                        <RiMessage3Line className='menu-icon'/>
                    </div>
                    <div className={`menu-icon-container tooltip ${menuIndex === 1 ? "menu-icon-selected" : null}`}
                         onClick={() => setMenuIndex(1)}>
                        <span className="tooltiptext" style={{left:-3}}>Requests</span>
                        <RiUser2Line className='menu-icon'/>
                    </div>
                    <div className={`menu-icon-container tooltip ${menuIndex === 2 ? "menu-icon-selected" : null}`}
                         onClick={() => setMenuIndex(2)}>
                        <span className="tooltiptext" style={{left:3}}>Groups</span>
                        <RiGroupLine className='menu-icon'/>
                    </div>
                    <div className={`menu-icon-container tooltip ${menuIndex === 3 ? "menu-icon-selected" : null}`}
                         onClick={() => setMenuIndex(3)}>
                        <span className="tooltiptext" style={{left:-2}}>Settings</span>
                        <RiSettings2Line className='menu-icon'/>
                    </div>
                    <div className={`menu-icon-container tooltip ${menuIndex === 4 ? "menu-icon-selected" : null}`}
                         onClick={() => logout()}>
                        <span className="tooltiptext" style={{left:3}}>Logout</span>
                        <RiLogoutBoxLine className='menu-icon'/>
                    </div>
                </div>
                <div className="bot tooltip" onClick={() => setMenuIndex(-1)}>
                    <span className="tooltiptext" style={{left:-7, top:-30}}>Profile</span>
                    {
                        user && !!user.avatarImage ?
                            <div className='avatar'
                                 dangerouslySetInnerHTML={{__html: multiavatar(user.avatarImage)}}>
                            </div>
                            :
                            <RiAccountCircleFill className='avatar-icon'/>
                    }
                </div>
            </div>
        );
    }

    const menuVertical = () => {
        return (
            <div className='menu-container-vertical'>
                <div className={`menu-icon-container tooltip ${menuIndex === 0 ? "menu-icon-selected" : null}`}
                     onClick={() => setMenuIndex(0)}>
                    <span className="tooltiptext" style={{left:3}}>Chats</span>
                    <RiMessage3Line className='menu-icon'/>
                </div>
                <div className={`menu-icon-container tooltip ${menuIndex === 1 ? "menu-icon-selected" : null}`}
                     onClick={() => setMenuIndex(1)}>
                    <span className="tooltiptext" style={{left:3}}>Requests</span>
                    <RiUser2Line className='menu-icon'/>
                </div>
                <div className={`menu-icon-container tooltip ${menuIndex === 2 ? "menu-icon-selected" : null}`}
                     onClick={() => setMenuIndex(2)}>
                    <span className="tooltiptext" style={{left:3}}>Groups</span>
                    <RiGroupLine className='menu-icon'/>
                </div>
                <div className={`menu-icon-container tooltip ${menuIndex === 3 ? "menu-icon-selected" : null}`}
                     onClick={() => setMenuIndex(3)}>
                    <span className="tooltiptext" style={{left:3}}>Settings</span>
                    <RiSettings2Line className='menu-icon'/>
                </div>
                <div className={`menu-icon-container tooltip ${menuIndex === 4 ? "menu-icon-selected" : null}`}
                     onClick={() => logout()}>
                    <span className="tooltiptext" style={{left:3}}>Logout</span>
                    <RiLogoutBoxLine className='menu-icon'/>
                </div>
                <div className="bot tooltip" onClick={() => setMenuIndex(-1)}>
                    <span className="tooltiptext" style={{left:-9, top:-32}}>Profile</span>
                    {
                        user && !!user.avatarImage ?
                            <div className='avatar'
                                 dangerouslySetInnerHTML={{__html: multiavatar(user.avatarImage)}}>
                            </div>
                            :
                            <RiAccountCircleFill className='avatar-icon'/>
                    }
                </div>
            </div>
        );
    }

    return (
        <Container>
            {menuHorizontal()}
            {menuVertical()}
            {renderSwitch(menuIndex)}
        </Container>
    );
}

SideMenu.prototype = {
    user: PropTypes.object,
    logout: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    user: state.auth.user,
});

export default connect(mapStateToProps, {logout})(SideMenu);

const Container = styled.div`
  height: 100vh;
  display: grid;
  grid-template-columns: 75px 400px;

  .menu-container-vertical {
    display: none;
  }

  @media screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column-reverse;
    grid-template-columns: none;

    .menu-container-horizontal {
      display: none !important;
    }

    .menu-container-vertical {
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
  }

  .menu-container-horizontal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      width: 0.2rem;

      &-thumb {
        background-color: #D1D6DB;
        width: 0.1rem;
        border-radius: 1rem;
      }
    }
  }

  .top {
    padding-top: 20px;
  }

  .mid {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
  }

  .bot {
    cursor: pointer;

    .avatar {
      width: 2rem;
    }

    .avatar-icon {
      font-size: 35px;
    }
  }

  .menu-icon-container {
    color: #878A92;
    transition: 0.25s;
  }

  .menu-icon {
    font-size: 25px;
    padding: 15px;
    border-radius: 0.5rem;
    cursor: pointer;
  }

  .menu-icon-selected {
    background-color: #F7F7FF;
    color: #7269EF !important;
  }

  .tooltip {
    position: relative;
  }

  .tooltip .tooltiptext {
    transition: 0.5s;
    visibility: hidden;
    opacity: 0;
    background-color: #7269EF;
    color: #fff;
    text-align: center;
    border-radius: 0.25rem;
    padding: 5px;
    font-size: 0.75rem;

    /* Position the tooltip */
    position: absolute;
    top: -20px;
    z-index: 1;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }

  .hidden {
    display: none;
  }
`;